<template>
    <router-link :to="goto" class="game" :style="{'background-image': `url(${this.game.coverArt}` }" v-ripple :class='size'>
      <div>
          <p> {{game.title}} </p>
            <img v-if="size === 'wide'" loading="lazy" :src="'/' + game.console + '.png'"/>
      </div>
    </router-link>
</template>

<script>

export default {
  name: 'game',
  props: {
    game: Object,
    size: {
        type: String,
        default: function(){ return ''}
    }
  },

    computed: {
        goto: function(){
            if(this.isDesktop){
                return `/theater?mode=game&id=${this.game.id}`
            }
            return '/game/' + this.game.id

        }
    },

  data: function(){
      return {}
  },

  methods: {

  },

  mounted: function(){
  }
}
</script>

<style scoped lang="scss">
.game{
    min-width: 150px;
    position: relative;
    height: 250px;
    overflow: hidden;
    border-radius: 8px;
    background-size: cover;
    background-position: center;
    margin-right: 10px;
    color: white;
    &.wide{
        min-width: 250px;
        height: 150px;
        background-position: top center;
        div{
            width: 100%;
            left: unset;
            margin: 5px;
            height: auto;
            border-radius: 8px;
            right: 0;
            display: flex;
            background: rgba(black, 0.3);
            backdrop-filter: blur(9px);
            p{
                align-self: center;
                width: 100%;
                padding: 10px;
                text-align: right;
            }
            img{
                display: none;
            }
        }
    }
    &.short{
        height: 150px
    }

    div{
        width: calc(100% - 10px);
        margin: 5px;
        border-radius: 8px;
        left: 0;
        bottom: 0;
        position: absolute;
        background: rgb(207 205 205 / 7%);
        backdrop-filter: blur(10px);
        p{
            margin: 0;
            font-weight: bold;
            font-size: 9px;
            padding: 15px;
        }
    }
}
</style>
